import { FundStatus } from '@common/enums';

import { FundQueryMethod } from '../enums';

import { County } from './county';
import { Disease } from './disease';
import { Foundation } from './foundation';
import { FundCity } from './fund-city';
import { FundInsuranceType } from './fund-insurance-type';
import { FundSupportType } from './fund-support-type';
import { State } from './state';

export interface Fund {
  applicationRequirements?: string;
  applicationUrl?: string;
  cities?: FundCity[];
  cityCount?: any;
  stateCount?: any;
  countyCount?: any;
  closedDate?: Date;
  color?: string;
  counties?: County[];
  countiesCount?: any;
  description?: string;
  descriptionChangeDate?: Date;
  diseaseType?: string;
  diseases?: Disease[];
  foundation?: Foundation;
  foundationId?: number;
  frequency?: string;
  id?: number;
  fundInsuranceTypes?: FundInsuranceType[];
  fundSupportTypes?: FundSupportType[];
  grantAmount?: number;
  grantAmountDescription?: string;
  guid?: string;
  hasIncomeRequirement?: any;
  hasincomerequirement?: any;
  incomeRequirementDescription?: string;
  incomeRequirementMaxFpl?: number;
  lastUpdated?: Date;
  maxIncome?: any;
  maximumAge?: number;
  minimumAge?: number;
  nonFplIncomeRequirement?: any;
  nonfplincomerequirement?: any;
  notes?: string;
  pediatric?: boolean;
  queryDate?: Date;
  queryMessage?: string;
  queryMethod?: FundQueryMethod;
  queryState?: string;
  scraperProxy?: boolean;
  scraperProxyCountry?: string;
  scraperRealBrowser?: boolean;
  scraperAsp?: boolean;
  state?: string;
  states?: State[];
  status?: FundStatus;
  statusDate?: Date;
  url?: string;
  websiteUrl?: string;
}
